import Pusher from "pusher-js";

export default defineNuxtPlugin((nuxtApp) => {
  const userAuth = useCookie("auth.token");
  const config = useRuntimeConfig();

  // Initialize Pusher
  const pusher = new Pusher(config.public.pusherAppKey, {
    cluster: config.public.pusherAppCluster,
    encrypted: true,
    authEndpoint: config.public.pusherAuthUrl,
    auth: {
      headers: {
        Authorization: `Bearer ${userAuth.value}`,
      },
    },
  });

  // Inject Pusher as a global property
  nuxtApp.provide("pusher", pusher);
});
